import {
  LanguageCode,
  SignageClockFormat,
  SignageClockFormatLabels,
  SignageUnitSystem,
  SignageUnitSystemLabels
} from '@navio/nsdk';
import { LANGUAGE_CODE_LABELS } from 'noddi-util';

export const languageOptions = Object.values(LanguageCode).map((code) => ({
  value: code,
  label: LANGUAGE_CODE_LABELS[code]
}));

const CLOCK_FORMAT_LABEL: Record<SignageClockFormat, string> = {
  [SignageClockFormat.TWENTY_FOUR_HOUR]: SignageClockFormatLabels.TWENTY_FOUR_HOUR,
  [SignageClockFormat.TWELVE_HOUR]: SignageClockFormatLabels.TWELVE_HOUR
};

const UNIT_SYSTEM_LABEL: Record<SignageUnitSystem, string> = {
  [SignageUnitSystem.METRIC]: SignageUnitSystemLabels.METRIC,
  [SignageUnitSystem.IMPERIAL]: SignageUnitSystemLabels.IMPERIAL
};

/** Unit examples only in the picker — the field value stays the plain generated label. */
const UNIT_SYSTEM_EXAMPLES: Record<SignageUnitSystem, string> = {
  [SignageUnitSystem.METRIC]: '°C, mm, bar',
  [SignageUnitSystem.IMPERIAL]: '°F, in, psi'
};

export const clockFormatOptions = [SignageClockFormat.TWENTY_FOUR_HOUR, SignageClockFormat.TWELVE_HOUR].map(
  (value) => ({ value, label: CLOCK_FORMAT_LABEL[value] })
);

export const unitSystemOptions = [SignageUnitSystem.METRIC, SignageUnitSystem.IMPERIAL].map((value) => ({
  value,
  label: `${UNIT_SYSTEM_LABEL[value]} (${UNIT_SYSTEM_EXAMPLES[value]})`
}));

export const languageLabel = (code: LanguageCode | null | undefined): string =>
  code ? (LANGUAGE_CODE_LABELS[code] ?? code) : '—';

export const clockFormatLabel = (format: SignageClockFormat | null | undefined): string =>
  format ? (CLOCK_FORMAT_LABEL[format] ?? '—') : '—';

export const unitSystemLabel = (system: SignageUnitSystem | null | undefined): string =>
  system ? (UNIT_SYSTEM_LABEL[system] ?? '—') : '—';
